export function getCookie(cookieName: string) {
  const name = `${cookieName}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookies = decodedCookie.split(';')
  for (let cookie of cookies) {
    cookie = cookie.trim()
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length)
    }
  }
  return ''
}

export function setCookie(
  cookieName: string,
  cookieValue: string,
  expiresAt?: Date
) {
  const expires = expiresAt ? `; expires=${expiresAt.toUTCString()}` : ''
  document.cookie = `${cookieName}=${cookieValue}; path=/${expires}`
}
